import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { rules, axiosConfig } from 'api';
import { AxiosResponse } from 'axios';
import { RootState } from 'store';

import useStoreTranslation from 'hooks/useStoreTranslation';
import useToast from 'hooks/useToast';
import { GroupedListModel } from 'models/groupedList';
import { RulesResponse } from 'models/rule';
import RulesList from 'screens/components/RulesList';

const RulesListContainer = () => {
  const { t } = useStoreTranslation();
  const toast = useToast();

  const companyId = useSelector((state: RootState) => state.user.accountResult?.companyId);

  const [ruleList, setRuleList] = useState<GroupedListModel[]>([]);
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    const getData = async () => {
      setLoading(true);
      try {
        const {
          data: { data },
        } = await rules.get<AxiosResponse<RulesResponse[]>>('/rules/getall', axiosConfig);
        setRuleList(
          data.map((rule: RulesResponse) => ({
            id: rule.id,
            name: rule.name,
            badges: rule.groups.map((badge) => ({ id: badge.userGroupId, name: badge.userGroupName })),
          })),
        );
      } catch (error) {
        toast.add({
          type: 'danger',
          message: t('group.groupAggregation.errorFetch'),
        });
        setLoading(false);
      }
      setLoading(false);
    };
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyId]);

  return <RulesList ruleList={ruleList} isLoading={isLoading} />;
};

export default RulesListContainer;
